var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTripleWhaleLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0C70F2",
  d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M29.996 38.269a.66.66 0 0 1-.665.73h-9.954a.68.68 0 0 1-.684-.694V24.23a.736.736 0 0 0-.627-.72c-2.095-.33-8.827-2.002-11.427-9.391-.153-.43.167-.908.615-.92h7.533C21.01 13.476 25.68 17.513 27.56 23l.012-.012c1.564 4.573 2.248 12.79 2.425 15.279zM40.766 13.996c-2.414 7.125-7.377 8.777-10.248 9.396a.606.606 0 0 1-.681-.445c-.914-3.317-2.186-5.133-3.837-6.699-.28-.263-.269-.727.054-.937 1.931-1.31 4.315-2.102 7.293-2.107V13.2h6.856a.6.6 0 0 1 .563.795z",
  clipRule: "evenodd"
})));
export default SvgTripleWhaleLogo;